module.exports = __webpack_public_path__ + "static/img/2.360ef3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/zh/2.png
// module id = INTv
// module chunks = 0